import React from "react";
import { Col, FormControl, InputGroup } from "react-bootstrap";
import { formatFieldValue } from "./helper";

const SolarField = ({ field, data, increaseDataPoint, decreaseDataPoint }) => {
  const value = formatFieldValue(data[field.name], field.unit);

  return (
    <>
      <Col className="field-column" md={5}>
        <span> {field.title} </span>
      </Col>
      <Col className=" fc-with-input" md={7}>
        <InputGroup className="solar-item-field">
          <InputGroup.Prepend
            onClick={() => decreaseDataPoint(data, field.name)}
          >
            <InputGroup.Text>
              {" "}
              <i className="input arrows fa fa-caret-down input-arrow"></i>{" "}
            </InputGroup.Text>
          </InputGroup.Prepend>
          <FormControl
            placeholder={field.title}
            size="lg"
            // type="number"
            className="no-border-input"
            value={value}
            // onChange={(e) => setValue(formatFieldValue(e.target.value))}
            disabled
          />
          <InputGroup.Append
            onClick={() => increaseDataPoint(data, field.name)}
          >
            <InputGroup.Text>
              <i className="fa fa-caret-up input-arrow"></i>
            </InputGroup.Text>
          </InputGroup.Append>
        </InputGroup>
      </Col>
    </>
  );
};

export default SolarField;
